import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b3d242e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "task-time-tracker-popover__target" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "task-time-tracker-popover__label" }, "Учет времени", -1))
const _hoisted_3 = { class: "task-time-tracker-popover__control-time" }

import { computed, onMounted, onUnmounted, PropType, ref } from "vue";
import { TirPmPopover, TirPmScrollbar } from "tir-components";
import { ClockIcon } from "tir-style-system/icons/outline";
import TaskTimeTracker from "./task-time-tracker.vue";
import { TaskTimeRecordModel, TaskTimeCreateRecordModel, TaskTimerEditRecordModel } from "./models";


export default /*#__PURE__*/_defineComponent({
  __name: 'task-time-tracker-popover',
  props: {
  /**Заблокировать */
  isDisabled: {
    type: Boolean,
    default: false,
  },
  /**Записи */
  records: {
    type: Array as PropType<Array<TaskTimeRecordModel>>,
    default: [],
  },
  /**Дата старта таймера */
  timerStartDate: {
    type: Date,
  },
  /**Загрузка */
  isLoading: {
    type: Boolean,
    default: false,
  },
  /**Является ли пользователь админом проекта */
  isProjectAdmin: { type: Boolean },
},
  emits: ["onOpenPopover", "onClosePopover", "onStart", "onStop", "onCreateRecord", "onDeleteRecord", "onEditRecord"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;





const $timeTracker = ref<InstanceType<typeof TaskTimeTracker>>();

/**Текущая дата */
const currentDate = ref(new Date());

let intervalId: number;

/**Расчитать разницу */
const calculateTimeDifference = (
  date1: Date,
  date2: Date,
): { hours: number; minutes: number; seconds: number } => {
  // Получаем разницу в миллисекундах между двумя датами
  const diffInMs = Math.abs(date2.getTime() - date1.getTime());

  // Переводим разницу в часы, минуты и секунды
  const hours = Math.floor(diffInMs / (1000 * 60 * 60));
  const minutes = Math.floor((diffInMs % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.round((diffInMs % (1000 * 60)) / 1000);

  return { hours, minutes, seconds };
};

const formatNumber = (num: number) => {
  return num > 9 ? num.toString() : `0${num}`;
};

const getDiffTimeStr = (date1: Date, date2: Date) => {
  const { hours, minutes, seconds } = calculateTimeDifference(date1, date2);

  return `${formatNumber(hours)}:${formatNumber(minutes)}:${formatNumber(seconds)}`;
};

const timeStr = computed(() => {
  if (props.timerStartDate) return getDiffTimeStr(props.timerStartDate, currentDate.value);
  return "00:00:00";
});

onMounted(() => {
  intervalId = setInterval(() => {
    currentDate.value = new Date();
  }, 250);
});
onUnmounted(() => {
  if (intervalId) clearInterval(intervalId);
});

__expose({
  $timeTracker,
  clearInputValue: () => $timeTracker.value?.clearInputValue(),
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(TirPmPopover), {
    "custom-position": { left: '-8.75rem', top: '0.25rem + $el:height' },
    "is-disabled": __props.isDisabled,
    onOpen: _cache[5] || (_cache[5] = ($event: any) => (emit('onOpenPopover'))),
    onClose: _cache[6] || (_cache[6] = ($event: any) => (emit('onClosePopover')))
  }, {
    content: _withCtx(() => [
      _createVNode(_unref(TirPmScrollbar), { style: { 'max-height': '24rem' } }, {
        default: _withCtx(() => [
          _createVNode(TaskTimeTracker, {
            ref_key: "$timeTracker",
            ref: $timeTracker,
            records: __props.records,
            "timer-start-date": __props.timerStartDate,
            "is-loading": __props.isLoading,
            isProjectAdmin: __props.isProjectAdmin,
            onOnStart: _cache[0] || (_cache[0] = ($event: any) => (emit('onStart', $event))),
            onOnStop: _cache[1] || (_cache[1] = ($event: any) => (emit('onStop'))),
            onOnCreateRecord: _cache[2] || (_cache[2] = ($event: any) => (emit('onCreateRecord', $event))),
            onOnDeleteRecord: _cache[3] || (_cache[3] = ($event: any) => (emit('onDeleteRecord', $event))),
            onOnEditRecord: _cache[4] || (_cache[4] = ($event: any) => (emit('onEditRecord', $event)))
          }, null, 8, ["records", "timer-start-date", "is-loading", "isProjectAdmin"])
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _createElementVNode("div", {
          class: _normalizeClass(['task-time-tracker-popover__control', { 'is-disabled': __props.isDisabled }])
        }, [
          _createVNode(_unref(ClockIcon), { class: "task-time-tracker-popover__control-icon" }),
          _createElementVNode("span", _hoisted_3, _toDisplayString(timeStr.value), 1)
        ], 2)
      ])
    ]),
    _: 1
  }, 8, ["is-disabled"]))
}
}

})